document.cookie = 'browsercapabilities='+(document.getElementsByTagName('html')[0].className.replace(/^\s+|\s+$/g, '').split(' ').join('|'));